import { mediaQueries } from '../utils/breakpoints'
import { gsap } from './registerGsap'

export const motionConditions = {
  desktop: mediaQueries.desktopMotion,
  tablet: mediaQueries.tablet,
  mobile: '(max-width: 767px)',
  landscapeMobile: mediaQueries.landscapeMobile,
  reduceMotion: mediaQueries.reducedMotion,
} as const

export type MotionConditionState = Record<keyof typeof motionConditions, boolean>

export function createMotionMedia(): gsap.MatchMedia {
  return gsap.matchMedia()
}
